var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":_vm.title}},[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Open"}},[_c('New')],1),_c('vs-tab',{attrs:{"label":"Active"}},[_c('Active')],1),_c('vs-tab',{attrs:{"label":"Inactive"}},[_c('Inactive')],1),_c('vs-tab',{attrs:{"label":"Canceled"}},[_c('Canceled')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }